import { render, staticRenderFns } from "./defaultValue-editor.vue?vue&type=template&id=5a88e4e6&scoped=true&"
import script from "./defaultValue-editor.vue?vue&type=script&lang=js&"
export * from "./defaultValue-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a88e4e6",
  null
  
)

export default component.exports